import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createWebCountry } from '../../actions/web-countries';
import { fetchCountries } from '../../actions/countries';
import { resetError } from '../../actions/errors';
import WebCountryForm from './form';

class WebCountryNew extends React.Component {
  componentWillMount() {
    this.props.getCountries();
  }

  render() {
    const {
      countries, createAction, goToList, resetErrorAction,
    } = this.props;
    const submit = (body) => {
      resetErrorAction();
      return createAction(body).then((result) => {
        if (result.ok) goToList();
        return result;
      });
    };
    return (
      <WebCountryForm
        countries={countries}
        title="New web country"
        submitLabel="Create"
        onSubmit={submit}
        cancel={goToList}
      />
    );
  }
}

WebCountryNew.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.object),
  createAction: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  resetErrorAction: PropTypes.func.isRequired,
};

WebCountryNew.defaultProps = { countries: [] };

const mapStateToProps = ({ countries }) => ({ countries: countries.items });
const mapDispatchToProps = dispatch => bindActionCreators({
  createAction: body => createWebCountry(body),
  getCountries: () => fetchCountries(),
  goToList: () => push('/web-countries'),
  resetErrorAction: () => resetError(),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCountryNew);
